import { useEffect, useState } from "react";
import MultiCheckSelect from "../../option-select/MultiCheckSelect";
import { reactSelectTheme } from "../../option-select/reactSelectTheme";
import { searchWithFilters, createListQuery } from "../../../services/api/search";

interface WorkorderTypeSelectProps {
    value?: any,
    onChange?: (values: any) => void,
    disabled?: boolean
}

/**
* WorkorderTypeSelect: Select workorder type component
* Used to select workorder types for filtering
* @param value - Selected values
* @param onChange - On change callback
* @param disabled - Disabled state
*/
const WorkorderTypeSelect = (props: WorkorderTypeSelectProps) => {
  const [workorderTypeListState, setWorkorderTypeListState] = useState<any[]>([]);
  const [valueState, setValueState] = useState<any>(null);

  useEffect(() => {
    // Récupérer la liste des types de workorder depuis l'API
    searchWithFilters<EasyTech.WorkorderType>("workorder_types", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, false)
      .then((response) => {
        const types = response.data as EasyTech.WorkorderType[];
        const options = types
          .filter(type => type.enabled) // Filtrer seulement les types activés
          .map((type) => ({
            value: type.id,
            label: type.label
          }));
        setWorkorderTypeListState(options);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des types de workorder:", error);
        setWorkorderTypeListState([]);
      });
  }, []);

  useEffect(() => {
    if (props.value) {
      if (Array.isArray(props.value)) {
        setValueState(props.value.map((val: any) => {
          const type = typeof val === "string" ? val : val.id;
          const option = workorderTypeListState.find(opt => opt.value === type);
          return option || { value: type, label: type };
        }));
      } else {
        const type = typeof props.value === "string" ? props.value : props.value.id;
        const option = workorderTypeListState.find(opt => opt.value === type);
        setValueState(option || { value: type, label: type });
      }
    } else {
      setValueState(null);
    }
  }, [props.value, workorderTypeListState]);

  const workorderTypeChange = ((value: any) => {
    setValueState(value);
    if (props.onChange) {
      if (Array.isArray(value)) {
        props.onChange(value.map((val: {value: string, label: string}) => val.value));
      } else if (value) {
        props.onChange(value.value);
      } else {
        props.onChange(null);
      }
    }
  });

  return (
    <div className="flex w-full min-w-0">
      <MultiCheckSelect options={workorderTypeListState}
        value={valueState}
        theme={reactSelectTheme}
        onChange={workorderTypeChange}
        name="workorderType"
        placeholder="Sélectionner un type d'intervention"
        className="min-w-0 w-full"
        classNamePrefix="react-select"
        isDisabled={props.disabled} />
    </div>
  );
};

export default WorkorderTypeSelect;